import { SxProps, Theme } from '@mui/material'

export const containerSx: SxProps<Theme> = {
  padding: {
    xs: '6rem 2.4rem ',
    md: '6rem 5.6rem',
    lg: '12rem 4.8rem',
  },
  background: {
    xs: 'url(/images/features-testimonial-1-bg.webp) no-repeat top right 50%',
    md: 'url(/images/features-testimonial-1-bg.webp) no-repeat top right',
  },
  backgroundSize: 'cover !important',
}

export const contentSx: SxProps<Theme> = {
  maxWidth: {
    xs: '100%',
    lg: '134.4rem',
    xl: '182.4rem',
  },
  margin: 'auto',
}

export const testimonialContainerSx: SxProps<Theme> = {
  maxWidth: {
    xs: '100%',
    md: '72.2rem',
    lg: '67.2rem',
    xl: '91.2rem',
  },
  margin: {
    md: '0 auto',
    lg: 'initial',
  },
  marginRight: {
    lg: 'auto',
  },
}
